module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.showPage && _vm.show_poll) ? [(!_vm.loading_poll) ? _c(_vm.poll_page, {
    tag: "components",
    staticClass: "show-poll",
    attrs: {
      "selectedPoll": _vm.selected_poll,
      "realTimeVote": _vm.realTimeVote
    },
    on: {
      "selectPoll": _vm.selected_poll_id,
      "deletePoll": function($event) {
        _vm.show_delete_poll = true
      },
      "closePollDialog": function($event) {
        _vm.show_poll = false
      },
      "close": function($event) {
        _vm.realTimeVote ? (_vm.show_poll = false) : _vm.$emit('close')
      }
    }
  }) : _c('div', {
    staticClass: "flex middle-xs center-xs",
    staticStyle: {
      "height": "500px"
    }
  }, [_c('p', {
    staticClass: "pulsate"
  }, [_vm._v("...loading poll")])]), _vm._v(" "), _c('div', [(_vm.show_delete_poll) ? _c('dialog-delete-confirm', {
    attrs: {
      "optionalText": "Delete Poll",
      "subHeader": 'Are you sure you want to delete this poll? This action is irreversible!'
    },
    on: {
      "close": function($event) {
        _vm.show_delete_poll = false
      },
      "actionConfirmed": _vm.deletePoll
    }
  }) : _vm._e()], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3daa7fac!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/polls_mvp/polls.modal.vue
// module id = 1876
// module chunks = 61